(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('EventCollections', EventCollections);

    EventCollections.$inject = ['$http', 'SoopkitchenUtils', 'FileUploadService', '$uibModal'];

    function EventCollections ($http, SoopkitchenUtils, FileUploadService, $uibModal) {
        return {
            getEventCollections:getEventCollections,
            getEventCollection:getEventCollection,
            createTimeline: createTimeline,
            merge: merge,
            createparameters: createparameters,
            openDeleteDialog: openDeleteDialog,
            deleteEventCollection : deleteEventCollection,
            uploadEventCollection:uploadEventCollection,
            getEventCollectionsLabels: getEventCollectionsLabels,
            setValidityEventCollection: setValidityEventCollection,
            pickValidityDialog: pickValidityDialog
        };

        function getEventCollections(success, failure) {
            $http({
                method: 'GET',
                url: 'api/event-collections/'
            }).then(success, failure);
        }

        function getEventCollectionsLabels(success, failure) {
            $http({
                method: 'GET',
                url: 'api/event-collections/labels'
            }).then(success, failure);
        }

        function setValidityEventCollection(label, startDateTime, endDateTime, success, failure) {
            $http({
            method: 'PUT',
            url: 'api/event-collections/update-validity/' + label,
                params: { startDateTime: startDateTime ,
                    endDateTime: endDateTime}

            }).then(success, failure);
        }
        function getEventCollection(label, success, failure) {
            $http({
                method: 'GET',
                url: 'api/event-collections/' + label
            }).then(success, failure);
        }
        function createOptions(eventCollections) {
            var options = {
                orientation: 'both',
                multiselect: false,
                editable: false,
                groupEditable: false,
                groupOrder: function (a, b) {
                    return a.orderId > b.orderId;
                },
                stack: false,
                stackSubgroups: true,
                margin: {
                    item: {
                        horizontal: 0
                    }
                },
                moment: function (date) {
                    return vis.moment(date).utc();
                },
                tooltip: {
                    followMouse: false,
                    overflowMethod: 'cap'
                },

                min: eventCollections.validityStartTime,
                max: eventCollections.validityEndTime,

                onMoving: function () {
                    return false;
                },
                onAdd: function () {
                    return false;
                },
                onUpdate: function () {
                    return false;
                },

                onRemove: function () {
                    return false;
                }
            };
            return options;
        }


        function createEventObject(i, title, content, occurrence, group, subgroup, style) {
            var eventObj = {
                id: (i + 1),
                title: title,
                content: content,
                start: occurrence.startDate,
                group: group,
                subgroup: subgroup,
                style: style
            };

            if (occurrence.startDate !== occurrence.endDate) {
                eventObj.end = occurrence.endDate;
            } else {
                eventObj.className = 'instantaneous';

            }
            return eventObj;
        }

        function extractParametersDescription(occurrence, title) {
            if (Object.keys(occurrence.parameters).length) {
                for (var parameter in occurrence.parameters) {
                    if (occurrence.parameters.hasOwnProperty(parameter)) {
                        title += parameter + ": " + occurrence.parameters[parameter] + '<br>';
                    }
                }
            }
            return title;
        }

        function createTimeline(container, eventCollections, events) {
            var timelineObjects = [];
            var groupsSet = new Set();
            var options = createOptions(eventCollections);
            for (var i = 0; i < events.length; i++) {
                var occurrence = events[i].happening;
                var group = occurrence.group.groupName;
                var style = 'background-color: ' + occurrence.colour + ';' + 'border-color: ' + occurrence.colour + ';';
                var startString = occurrence.startDate + ' (' + SoopkitchenUtils.getDayOfYear(occurrence.startDate) + ')';
                var endString = occurrence.endDate + ' (' + SoopkitchenUtils.getDayOfYear(occurrence.endDate) + ')';
                var content = "<span id='timelineOccurrence_" + i + "' style ='" + style + "'>" + occurrence.name;
                var title = content;

                if (groupsSet.has(group) === false) {
                    groupsSet.add(group);
                }

                if (occurrence.description) {
                    title += ' (' + occurrence.description + ')'
                }

                title += "</span>";
                if (occurrence.startDate === occurrence.endDate) {
                    title += '<br>' + startString + '<br>';
                    style = SoopkitchenUtils.styleForInstantEvent(style);
                    content = "<span id='timelineOccurrence_" + i + "' style ='visibility: hidden;'>" + occurrence.name + " </span>";
                } else {
                    title += '<br>' + startString + '->' + endString + '<br>';
                }

                var subgroup = "";
                if (occurrence.group.subgroupName) {
                    subgroup = occurrence.group.subgroupName;
                } else {
                    subgroup = occurrence.originalName;
                }
                if (occurrence.count) {
                    title += 'count: ' + occurrence.count + '<br>';
                }
                title = extractParametersDescription(occurrence, title);
                title += '<hr style="display: block; margin: 6px"/>Source: ' + events[i].source + '<br>';
                timelineObjects.push(createEventObject(i, title, content, occurrence, group, subgroup, style));
            }

            container.innerHTML = "";

            var timelineGroups = new vis.DataSet(createGroups(groupsSet));
            var timelineItems = new vis.DataSet(timelineObjects);
            return new vis.Timeline(container, timelineItems, timelineGroups, options);
        }

        function createGroups(groupSet) {
            var groups = Array.from(groupSet);
            var timelineGroups = [];
            for (var i = 0; i < groups.length; i++) {
                var group = groups[i];
                var style = "background-color: #F5F5F5;";
                timelineGroups.push({
                    id: group,
                    value: group,
                    'content': '<span id="group_' + group + '">' + group + '</span>',
                    'style': style,
                    orderId: group
                });
            }
            return timelineGroups;
        }

        function createparameters(event) {
            var str = '';
            var parameters = event.parameters;
            var count = event.count;
            if (Object.keys(parameters).length > 0 || count > 0) {
                str = '{';
                if (count > 0) {
                    str += '"count" : ' + count + ', ';
                }
                for (var key in parameters) {
                    // check if the property/key is defined in the object itself, not in parent
                    if (parameters.hasOwnProperty(key)) {
                        str += '"' + key + '" : "' + parameters[key] + '", ';
                    }
                }
                str = str.substring(0, str.length - 2);
                str += '}';
            }
            return str;
        }
        function merge(checked,labelVal,description,  success, failure) {
            var collections = [];
            for (var collectionLabel in checked) {
                if (checked.hasOwnProperty(collectionLabel) && checked[collectionLabel]) {
                    collections.push(collectionLabel)
                }
            }
            $http({
                method: 'POST',
                url: 'api//event-collections/merge',
                params: {
                    "eventCollections" : collections,
                    "label": labelVal,
                    "description" : description
                }

            }).then(success, failure);

        }
        function deleteEventCollection(label, success, failure) {
            $http({
                method: 'DELETE',
                url: 'api/event-collections/' + label
            }).then(function successCallback(response) {
                success (response);
            }, function errorCallback(response) {
                failure(response);
            })
        }
        function openDeleteDialog(label) {
            $uibModal.open({
                templateUrl: 'app/entities/event-collections/event-collections-delete-dialog.html',
                controller: 'EventCollectionsDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    parameters: {
                        label: label
                    }
                }
            });
        }

        function uploadEventCollection(label, files, description, success, failure) {
            FileUploadService.uploadFiles(files, 'api/event-collections/multi-files-upload', label, success,
                failure,
                FileUploadService.progressCallback,
                description);
        }

        function pickValidityDialog(label, validityStartTime, validityEndTime) {
            $uibModal.open({
                templateUrl: 'app/entities/event-collections/event-collections-update.html',
                controller: 'EventCollectionsUpdateValidityController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    parameters: {
                        label: label,
                        validityStartTime: validityStartTime,
                        validityEndTime: validityEndTime
                    }
                }
            });
        }
    }
})();
